export const Layout = () => import('@/layout/index.vue')
import { getRouteRoles } from '@/utils/index'

/**
 * 标签印刷AI订单系统路由
 */
const routes = {
  path: '/label',
  redirect: 'noRedirect',
  component: Layout,
  meta: {
    icon: 'Document',
    title: '标签订单',
    roles: [],
    activeMenuTop: '/label',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  },
  children: [
    {
      path: 'order',
      name: 'LabelOrderList',
      component: () => import('@/views/label/order/list.vue'),
      meta: {
        title: '订单管理',
        icon: 'List',
        roles: ['admin/label.Order/list'],
        activeMenuTop: '/label',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'customer',
      name: 'LabelCustomerList',
      component: () => import('@/views/label/customer/list.vue'),
      meta: {
        title: '客户管理',
        icon: 'User',
        roles: ['admin/label.Customer/list'],
        activeMenuTop: '/label',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'price-rule',
      name: 'LabelPriceRuleList',
      component: () => import('@/views/label/price-rule/list.vue'),
      meta: {
        title: '价格规则',
        icon: 'Money',
        roles: ['admin/label.PriceRule/list'],
        activeMenuTop: '/label',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'channel',
      name: 'LabelChannelIndex',
      component: () => import('@/views/label/channel/index.vue'),
      meta: {
        title: '渠道管理',
        icon: 'Connection',
        roles: ['admin/label.Channel/list'],
        activeMenuTop: '/label',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    }
  ]
}

routes.meta.roles = getRouteRoles(routes)

export default routes
